import beautyPieLogo from "../../public/images/beauty-pie-logo.jpg";
import outOfStockReview from "../../public/images/outOfStockReview.svg";
import placeholder from "../../public/images/placeholder.svg";
import reviewStars from "../../public/images/reviewStars.svg";
import homePageReviewStars from "../../public/images/nm-homepage/reviews/stars.svg";

export type StaticFile =
  | "/images/beauty-pie-logo.jpg"
  | "/images/outOfStockReview.svg"
  | "/images/placeholder.svg"
  | "/images/reviewStars.svg"
  | "/images/nm-homepage/reviews/stars.svg";

declare global {
  interface Window {
    staticFiles: StaticFile;
  }
}

const fileMap = {
  "/images/beauty-pie-logo.jpg": beautyPieLogo.src,
  "/images/outOfStockReview.svg": outOfStockReview.src,
  "/images/placeholder.svg": placeholder.src,
  "/images/reviewStars.svg": reviewStars.src,
  "/images/nm-homepage/reviews/stars.svg": homePageReviewStars.src
};

const unoptimized =
  process.env.STORYBOOK === "true" ||
  process.env.NODE_ENV === "test" ||
  process.env.NODE_ENV === "development";

export function getStaticFile(path: StaticFile): string {
  return unoptimized ? path : fileMap[path];
}
